<!--
 * @Author: your name
 * @Date: 2020-07-02 15:55:51
 * @LastEditTime: 2021-12-21 13:38:58
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath     : \vue-gaokao-ebook\src\components\header\header.vue
--> 
<template>
  <div class="header">
    <div class="content">
      <div class="logo-l">
        <img src="@/assets/images/header/logo.jpg" alt />
      </div>
      <ul class="nav_tab">
        <li
          :class="['item', { active: tab == 'home' }]"
          @click="clickButton('home')"
        >
          高考专家测评
        </li>
        <!-- <li :class="['item', { 'active': tab == 'my_evaluation' }]" @click="clickButton('my_evaluation')">我的测评</li> -->
        <!-- <li :class="['item', { 'active': tab == 'wrong_topic' }]" @click="clickButton('wrong_topic')">错题本</li> -->
        <li
          :class="['item', { active: tab == 'buy_members' }]"
          @click="clickButton('buy_members')"
        >
          会员
        </li>
        <li
          :class="['item', { active: tab == 'team' }]"
          @click="clickButton('team')"
        >
          专家团队
        </li>
        <li
          :class="['item', { active: tab == 'download' }]"
          @click="clickButton('download')"
        >
          软件下载
        </li>
        <li
          :class="['item', { active: tab == 'help' }]"
          @click="clickButton('help')"
        >
          帮助中心
        </li>
      </ul>
      <template v-if="model != 'client'">
        <div class="user_info" v-if="isLogin">
          <div class="user_name">{{ name }}</div>
          <div class="head_img">
            <el-dropdown trigger="click" @command="toMyCenterPage">
              <img :src="head_img_url" />
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="2" class="header-dropdown-item">
                <span class="el-icon-notebook-2"></span>我的测评
              </el-dropdown-item>
              <el-dropdown-item command="3" class="header-dropdown-item">
                <span class="el-icon-document-delete"></span>错题本
              </el-dropdown-item>
              <el-dropdown-item command="1" class="header-dropdown-item">
                <span class="item_end">
                  <span class="el-icon-user"></span>个人中心
                </span>
              </el-dropdown-item> -->
                <el-dropdown-item command="4" class="header-dropdown-item">
                  <!-- <span class="item">
                  <span class="el-icon-setting"></span>账号设置 
                </span> -->
                  <span class="el-icon-setting"></span>账号设置
                </el-dropdown-item>
                <!-- <el-dropdown-item command="6" class="header-dropdown-item">
                <span class="item">
                  <span class="el-icon-help"></span>帮助中心
                </span>
              </el-dropdown-item> -->
                <!-- <el-dropdown-item command="7" class="header-dropdown-item">
                <span class="el-icon-help"></span>帮助中心
              </el-dropdown-item> -->
                <el-dropdown-item command="9" class="header-dropdown-item">
                  <span class="el-icon-bank-card"></span>我的已购
                </el-dropdown-item>
      
                <el-dropdown-item command="10" class="header-dropdown-item">
                  <span class="el-icon-bank-card"></span>激活
                </el-dropdown-item>
                <!-- <el-dropdown-item command="8" class="header-dropdown-item">
                <span class="item">
                  <span class="el-icon-download"></span>软件下载 
                </span>
              </el-dropdown-item> -->
                <el-dropdown-item command="5" class="header-dropdown-item">
                  <span class="el-icon-switch-button"></span>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div v-if="!isLogin" class="login_register">
          <div
            class="login"
            :class="{ login: tab != 'login', login_select: tab == 'login' }"
            @click="clickButton('login')"
          >
            登录
          </div>
          <div
            class="register"
            :class="{
              register: tab != 'register',
              register_select: tab == 'register',
            }"
            @click="clickButton('register')"
          >
            注册
          </div>
        </div>
      </template>
    </div>
    <Login v-if="isShowLogin"></Login>
  </div>
</template>

<script>
import Login from "VIEWS/login/login";
import { mapState } from "vuex";
export default {
  name: "headers",
  data() {
    return {
      model: "",
      tab: "home",
      name: "用户名",
      head_img_url: require("../../assets/images/header/default.png"),
      current_path: "index",
      //用户是否登录
      isLogin: false,
      isShow: false,
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapState({
      isShowLogin: (state) => state.isShowLogin,
    }),
  },
  watch: {
    isLogin(val, oldVal) {
      //普通的watch监听
      if (val == false) {
        try {
          cefJS.sendmsg("logout");
        } catch (error) {
          console.log(error);
        }
      }
    },
  },
  methods: {
    clickButton: function (type) {
      this.$store.dispatch("selectTabType", type);
      if (type == "help") {
        window.open("/html/help.html", "_blank");
        return;
      }
      this.tab = type;
      if (this.isLogin) {
        if (type != "login") {
          if (type == "download") {
            this.$router.push(`/${type}`);
          } else {
            this.$router.push("/tfedu_common/" + type);
          }
        } else {
          this.tab = "login";
          this.$store.commit("changeIsShowLogin", true);
        }
      } else {
        if (type != "login") {
          if (type == "download") {
            this.$router.push(`/${type}`);
          } else {
            this.$router.push("/tfedu_common/" + type);
          }
        } else {
          this.$store.commit("changeIsShowLogin", true);
        }
      }
    },
    toMyCenterPage(val) {
      switch (+val) {
        case 1:
          this.$router.push({ path: "/my-personal/my_evaluation" });
          break;
        case 2:
          this.$router.push({ path: "/my-personal/my_evaluation" });
          break;
        case 3:
          this.$router.push({ path: "/my-personal/wrong_topic" });
          break;
        case 4:
          this.$router.push({ path: "/my-personal/setting" });
          break;
        case 7:
          window.open("/html/help.html", "_blank");
          break;
        case 8:
          this.$router.push({ path: "/download" });
          break;
        case 9:
          this.$router.push({ path: "/my-personal/vip" });
          break;
        case 10:
          this.$router.push({ path: "/my-personal/active" });
          break;
        // case 6:
        //   window.open("https://shimo.im/docs/Vckp8xKWyjYtQjtX/", "_blank");
        //   break;
        default:
          // 退出登陆操作
          this.$HTTP.executeGet(this.$APIS.USER_LOGOUT, this).then((res) => {
            if (!res.code) {
              window.localStorage.clear();
              this.$router.push({
                path: "/tfedu_common/home",
                query: {
                  t: new Date().getTime(),
                },
              });
            } else {
              this.$message.error("调用接口失败");
            }
          });
          break;
      }
    },
  },
  mounted() {
    try {
      CefSharp.BindObjectAsync("cefJS");
    } catch (error) {
      console.log(error);
    }
    this.current_path = this.$route.path;
    //控制tab位置
    this.$root.eventHub.$on("changePath", (tab) => {
      let changePath = this.$route.path;
      if (changePath.indexOf("/tfedu_common/home")) {
        this.tab = "home";
      } else if (changePath.indexOf("/tfedu_common/my_evaluation")) {
        this.tab = "my_evaluation";
      } else if (changePath.indexOf("/tfedu_common/wrong_topic")) {
        this.tab = "wrong_topic";
      } else if (changePath.indexOf("/tfedu_common/team")) {
        this.tab = "team";
      } else if (changePath.indexOf("/tfedu_common/help")) {
        this.tab = "team";
      } else if (changePath.indexOf("/tfedu_common/buy_members")) {
        this.tab = "buy_members";
      } else if (changePath.indexOf("/download")) {
        this.tab = "download";
      }
    });

    //根据页面路由控制按钮样式
    this.current_path = this.$route.path;
    if (this.current_path.indexOf("/tfedu_common/home") != -1) {
      this.tab = "home";
    }

    if (this.current_path.indexOf("/tfedu_common/my_evaluation") != -1) {
      this.tab = "my_evaluation";
    }

    if (this.current_path.indexOf("/tfedu_common/buy_members") != -1) {
      this.tab = "buy_members";
    }

    if (this.current_path.indexOf("/tfedu_common/team") != -1) {
      this.tab = "team";
    }

    if (this.current_path.indexOf("/tfedu_common/wrong_topic") != -1) {
      this.tab = "wrong_topic";
    }

    if (this.current_path.indexOf("/tfedu_common/register") != -1) {
      this.tab = "register";
    }

    if (this.current_path == "/index" || this.current_path == "/") {
      this.tab = "index";
    }

    if (this.current_path == "/download") {
      this.tab = "download";
    }

    // 首版隐藏
    // if (this.current_path == "/expert") {
    //   this.tab = "expert";
    // }
    // 首版显示
    if (this.current_path == "/expert") {
      this.tab = "home";
    }

    //监听登录关闭
    this.$root.eventHub.$on("show-login", (close) => {
      this.isShow = close;
    });
    //登录成功
    this.$root.eventHub.$on("show-login-succes", (islogin) => {
      let userInfo = window.localStorage.getItem("userinfo");

      this.isLogin = islogin;
      let user = JSON.parse(userInfo);
      this.name = user.nickname || user.fullName;
      this.head_img_url = user.avatar ? user.avatar : this.head_img_url;
    });

    this.$root.eventHub.$on("updata-user-info", () => {
      let user_json = localStorage.getItem("userinfo");
      const user = JSON.parse(user_json);
      this.name = user.nickname || user.fullName;
      this.head_img_url = user.avatar ? user.avatar : this.head_img_url;
    });
  },
  created() {
    // 兼容客户端
    let source = localStorage.getItem("model") || this.$route.query.model || "";
    this.model = source;
    localStorage.setItem("model", source);
    // 判断是否有
    // 首版隐藏
    if (this.$store.state.tabType) {
      this.tab = this.$store.state.tabType;
    }

    //判断是否登录,验证有效期
    //在页面渲染之前判断用户是否已经登录
    //先判断store中是否有用户信息
    let userInfo = window.localStorage.getItem("userinfo");
    if (userInfo != undefined && userInfo != null) {
      let user = JSON.parse(userInfo);
      this.isLogin = true;
      window.localStorage.setItem("isLogin", "true");
      this.name = user.nickname || user.fullName;
      this.head_img_url = user.avatar;
    }
    this.$HTTP.executeGet(this.$APIS.USER_ISLOGIN, this).then((response) => {
      if (response.code == 0) {
        let userInfo = window.localStorage.getItem("userinfo");
        if (userInfo != undefined && userInfo != null) {
          this.isLogin = true;
          window.localStorage.setItem("isLogin", "true");
          let user = JSON.parse(userInfo);
          this.name = user.nickname || user.fullName;
          this.head_img_url = user.avatar;
        } else {
          this.isLogin = false;
          window.localStorage.clear();
          if (
            this.current_path != "/" &&
            this.current_path != "/index" &&
            this.current_path != "/home" &&
            this.current_path != "/login" &&
            this.current_path != "/client_registering" &&
            this.current_path != "/client_logining" &&
            this.current_path != "/tfedu_common/register" &&
            this.current_path != "/download" &&
            this.current_path != "/photo_upload/index" &&
            this.current_path != "/reterieve_password" &&
            this.current_path != "/select_subject" &&
            this.current_path != "/tfedu_common/expert" &&
            this.current_path != "/tfedu_common/home" &&
            this.current_path != "/tfedu_common/team" &&
            this.current_path != "/tfedu_common/help" &&
            this.current_path != "/paper/pad_paper" &&
            this.current_path != "/tfedu_common/buy_members" &&
            this.current_path != "/shopping_mall" &&
            this.current_path != "/shopping_registering" &&
            this.current_path != "/web_login_register" &&
            this.current_path != "/web/setting" &&
            this.current_path != "/web/purchased" &&
            this.current_path != "/web_reterieve_password"
          ) {
            this.$store.commit("changeIsShowLogin", true);
            this.$message.error("登录超时,请重新登录!");
          } else {
            //如果是等于其中的一个则,直接跳转到该页面
          }
        }
      } else {
        this.isLogin = false;
        window.localStorage.clear();
        if (
          this.current_path != "/" &&
          this.current_path != "/index" &&
          this.current_path != "/home" &&
          this.current_path != "/login" &&
          this.current_path != "/client_registering" &&
          this.current_path != "/client_logining" &&
          this.current_path != "/tfedu_common/register" &&
          this.current_path != "/download" &&
          this.current_path != "/photo_upload/index" &&
          this.current_path != "/reterieve_password" &&
          this.current_path != "/select_subject" &&
          this.current_path != "/tfedu_common/expert" &&
          this.current_path != "/tfedu_common/home" &&
          this.current_path != "/tfedu_common/team" &&
          this.current_path != "/paper/pad_paper" &&
          this.current_path != "/tfedu_common/buy_members" &&
          this.current_path != "/shopping_mall" &&
          this.current_path != "/shopping_registering" &&
          this.current_path != "/web_login_register" &&
          this.current_path != "/web/setting" &&
          this.current_path != "/web/purchased" &&
          this.current_path != "/web_reterieve_password"
        ) {
          this.$store.commit("changeIsShowLogin", true);
          this.$message.error("登录超时,请重新登录!");
        } else {
          //如果是等于其中的一个则,直接跳转到该页面
        }
      }
    });
  },
};
</script>

<style scoped lang="stylus">
.header {
  width: 100%;
  height: 72px;
  color: #ffffff;
  background: #5c307d;
  font-size: 22px;
  text-align: center;
  line-height: 200%;
}

.content {
  width: 1520px;
  margin: 0 auto;
}

>>> .header-dropdown-item {
  font-size: 20px;
  color: #5c307d;
  line-height: 55px;
  width: 190px;
  text-align: left;

  .sphere {
    width: 9px;
    height: 9px;
    display: inline-block;
    border-radius: 9px;
    background: #5c307d;
    margin-right: 10px;
  }

  .item {
    display: inline-block;
    height: 100%;
    font-size: 20px;
    color: #5c307d;
    border-bottom: 1px solid #5c307d;
  }

  span {
    margin-right: 10px;
  }

  .item_end {
    display: inline-block;
    height: 100%;
    font-size: 20px;
    color: #5c307d;
    border-top: 1px solid #5c307d;
  }
}

>>> .el-dropdown-menu__item:not(.is-disabled):hover {
  color: #ffffff;
  background-color: #5c307d;

  .sphere {
    background-color: #fff;
  }

  .item_end, .item {
    color: #fff;
  }
}

.logo-l {
  float: left;
  text-align: center;
  height: 72px;
  margin-left: -85px;
  background-repeat: no-repeat;
  background-size: cover;
}

.logo-l img {
  height: 72px;
}

.nav_tab {
  width: auto;
  height: 72px;
  float: left;

  .item {
    font-size: 22px;
    cursor: pointer;
    float: left;
    padding: 0 30px;
    margin-left: 35px;
    margin-top: 15px;
    border-radius: 21px;
  }

  .active {
    background-color: #ffffff;
    color: #5c307d;
  }
}

.user_info {
  width: 180px;
  height: 46px;
  float: right;
  text-align: center;
  margin-top: 15px;
}

.user_info .user_name {
  height: 46px;
  line-height: 46px;
  float: left;
  width: 110px;
  text-align: right;
  margin-right: 20px;
  font-size: 18px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user_info .head_img {
  height: 46px;
  float: right;
  width: 46px;
  text-align: center;
  border-radius: 25px;
  background-color: #ffffff;
  cursor: pointer;
}

.user_info .head_img img {
  height: 46px;
  width: 46px;
  border-radius: 25px;
}

.login_register {
  width: 250px;
  height: 42px;
  line-height: 42px;
  margin-top: 15px;
  float: right;
  text-align: center;
  cursor: pointer;
  font-size: 22px;
}

.login_register .login {
  height: 42px;
  float: left;
  line-height: 42px;
  text-align: center;
  margin-left: 0px;
  margin-top: 0px;
  width: 100px;
  cursor: pointer;
  font-size: 22px;
}

.login_register .login_select {
  height: 42px;
  float: left;
  line-height: 42px;
  text-align: center;
  margin-left: 0px;
  margin-top: 0px;
  width: 100px;
  cursor: pointer;
  font-size: 22px;
  color: #5c307d;
  background-color: #ffffff;
  border-radius: 100px;
}

.login_register .register {
  height: 42px;
  float: right;
  line-height: 42px;
  text-align: center;
  margin-left: 50px;
  margin-top: 0px;
  width: 100px;
  cursor: pointer;
  font-size: 22px;
  text-align: center;
}

.login_register .register_select {
  height: 42px;
  float: right;
  line-height: 42px;
  text-align: center;
  margin-left: 50px;
  margin-top: 0px;
  width: 100px;
  cursor: pointer;
  font-size: 22px;
  color: #5c307d;
  background-color: #ffffff;
  border-radius: 100px;
  text-align: center;
}
</style>